<template>
  <div class="app-body">
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="$refs.table.reload()"
        ref="queryForm"
        class="query-form"
    >
      <!--      <el-form-item label="单据号：">-->
      <!--        <el-input v-model="dataForm.payNo" size="mini" clearable type="text"></el-input>-->
      <!--      </el-form-item>-->
      <el-form-item label="付款时间：">
        <div class="flex">
          <el-date-picker type="date" v-model="dataForm.payDateBegin" value-format="yyyy-MM-dd"
                          size="mini"></el-date-picker>
          <el-date-picker type="date" v-model="dataForm.payDateEnd" value-format="yyyy-MM-dd" style="margin-left: 10px;"
                          size="mini"></el-date-picker>
        </div>
      </el-form-item>
      <!--      <el-form-item label="付款金额：">-->
      <!--        <div class="flex">-->
      <!--        <el-input v-model="dataForm.payAmountMin" size="mini" clearable type="text"></el-input>-->
      <!--        <el-input v-model="dataForm.payAmountMax" size="mini" clearable type="text" style="margin-left: 10px;"></el-input>-->
      <!--        </div>-->
      <!--      </el-form-item>-->
      <el-form-item label="制单时间：">
        <div class="flex">
          <el-date-picker type="date" v-model="dataForm.createDateBegin" value-format="yyyy-MM-dd"
                          size="mini"></el-date-picker>
          <el-date-picker type="date" v-model="dataForm.createDateEnd" value-format="yyyy-MM-dd"
                          style="margin-left: 10px;"
                          size="mini"></el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="付款行：">
        <el-input v-model="dataForm.payBank" size="mini" clearable type="text"></el-input>
      </el-form-item>
      <el-form-item label="付款行：">
        <el-input v-model="dataForm.payBank" size="mini" clearable type="text"></el-input>
      </el-form-item>
      <el-form-item label="付款账号：">
        <el-input v-model="dataForm.payAccount" size="mini" clearable type="text"></el-input>
      </el-form-item>
      <el-form-item label="收款行：">
        <el-input v-model="dataForm.receiverBank" size="mini" clearable type="text"></el-input>
      </el-form-item>
      <el-form-item label="收款人：">
        <el-input v-model="dataForm.receiverName" size="mini" clearable type="text"></el-input>
      </el-form-item>
      <el-form-item label="收款账号：">
        <el-input v-model="dataForm.receiverAccount" size="mini" clearable type="text"></el-input>
      </el-form-item>

      <el-form-item label="制单人：">
        <el-input v-model="dataForm.creatorName" size="mini" clearable type="text"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button  @click="$refs.table.reload()" size="mini">查询</el-button>
<!--        <el-button type="primary" @click="createPrepayment" size="mini">预付款</el-button>-->
      </el-form-item>
    </el-form>
    <SweetTable ref="table" url="/erp/pay/money/page" :query-form="dataForm" :summaries-column="['payAmount']">
      <!--      <el-table-column prop="payNo" label="付款单据号" header-align="center" align="center"></el-table-column>-->
      <el-table-column prop="payDate" label="付款时间" header-align="center" align="center" width="110"></el-table-column>
      <el-table-column prop="payAmount" label="付款金额" header-align="center" align="center"></el-table-column>
      <el-table-column prop="payBank" label="付款行" header-align="center" align="center"></el-table-column>
      <el-table-column prop="receiptCodes" label="付款发票号" header-align="center" align="center"></el-table-column>
      <el-table-column prop="payAccount" label="付款账号" header-align="center" align="center"></el-table-column>
      <el-table-column prop="receiverBank" label="收款行" header-align="center" align="center"></el-table-column>
      <el-table-column prop="receiverName" label="收款人" header-align="center" align="center" :formatter="$c.companyNameFormatter"></el-table-column>
      <el-table-column prop="receiverAccount" label="收款账号" header-align="center" align="center"></el-table-column>
      <el-table-column prop="creatorName" label="制单人" header-align="center" align="center"></el-table-column>
      <el-table-column prop="createDate" label="制单时间" header-align="center" align="center" width="160"></el-table-column>
      <el-table-column prop="remark" label="备注" header-align="center" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column label="操作" header-align="center"
                       align="center" width="120">
        <template #default="{row}">
          <el-button type="text" @click="showDetail(row)">查看详情</el-button>
          <el-button type="text" @click="doDel(row)">删除</el-button>
        </template>
      </el-table-column>
    </SweetTable>
    <MoneyDetailDialog ref="MoneyDetailDialog"></MoneyDetailDialog>
    <CreatePrepayment ref="CreatePrepayment" @change="$refs.table.getDataList()"></CreatePrepayment>
  </div>
</template>

<script>
import MoneyDetailDialog from './detail-dialog.vue'
import CreatePrepayment from '@/views/modules/erp/pay/money/CreatePrepayment.vue'

export default {
  name: 'index',
  computed: {},
  components: { MoneyDetailDialog, CreatePrepayment },
  data () {
    return {
      dataForm: {
        payNo: '',
        payBank: '',
        payAccount: '',
        receiverBank: '',
        receiverName: '',
        receiverAccount: '',
        creatorName: '',
        createDateBegin: '',
        createDateEnd: '',
        payDateBegin: '',
        payDateEnd: ''
      },
    }
  },
  activated () {
    this.$nextTick(() => {
      this.$refs.table.reload()
    })
  },
  methods: {
    createPrepayment () {
      this.$refs.CreatePrepayment.init()
    },
    showDetail (row) {
      this.$refs.MoneyDetailDialog.init(row.id)
    },
    doDel (row) {
      this.$confirm(`是否要删除付款记录【${row.receiverName}(${row.payAmount})】？`, '操作提示').then(() => {
        this.$api.delete(`/erp/pay/money`, { data: [row.id] }).then(res => {
          this.$refs.table.getDataList()
          this.$message.success('删除成功')
        })
      })
    },
  }
}
</script>

<style scoped>

</style>
